import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './news-insights.css'

const NewsInsights = (props) => {
  return (
    <div className="news-insights-container1">
      <Helmet>
        <title>News-Insights - DFW Health Tech</title>
        <meta
          property="og:title"
          content="News-Insights - DFW Health Tech"
        />
        <link
          rel="canonical"
          href="https://dfwhealthtech.com/news-insights"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="news---insights-hero-section">
        <div className="hero-bg-wrapper">
          <video
            autoPlay="true"
            muted="true"
            loop="true"
            playsInline="true"
            src="https://videos.pexels.com/video-files/6010960/6010960-hd_1920_1080_25fps.mp4"
            className="hero-video"
          ></video>
          <div className="news---insights-hero-overlay"></div>
        </div>
        <div className="hero-content-outer">
          <div className="hero-diagonal-split">
            <div className="hero-text-region">
              <h1 className="news---insights-hero-title hero-title">
                <span>
                  DFW Health Tech
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
              </h1>
              <p className="news---insights-hero-subtitle hero-subtitle">
                The definitive source for aggregated health technology news,
                funding activity, and analyst insights in the Dallas-Fort Worth
                ecosystem.
              </p>
              <div className="hero-actions">
                <div className="hero-search-bar">
                  <div className="hero-icon-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="m21 21l-4.34-4.34"></path>
                        <circle cx="11" cy="11" r="8"></circle>
                      </g>
                    </svg>
                  </div>
                  <input
                    type="text"
                    placeholder="Search companies, sectors, or investors..."
                    className="hero-input"
                  />
                  <button className="btn btn-primary">Search</button>
                </div>
                <div className="hero-newsletter-prompt">
                  <span className="hero-tag">Join 5,000+ Professionals</span>
                  <button className="hero-cta-btn btn btn-outline">
                    Get Weekly Insights
                  </button>
                </div>
              </div>
            </div>
            <div className="hero-visual-region">
              <div className="hero-stats-float">
                <div className="hero-stat-card">
                  <div className="hero-stat-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M16 7h6v6"></path>
                        <path d="m22 7l-8.5 8.5l-5-5L2 17"></path>
                      </g>
                    </svg>
                  </div>
                  <div className="hero-stat-details">
                    <span className="hero-stat-value">$1.2B</span>
                    <span className="hero-stat-label">YTD Funding</span>
                  </div>
                </div>
                <div className="hero-stat-card">
                  <div className="hero-stat-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 2v20m5-17H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
                      ></path>
                    </svg>
                  </div>
                  <div className="hero-stat-details">
                    <span className="hero-stat-value">42</span>
                    <span className="hero-stat-label">Active Investors</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="updates-section">
        <div className="updates-header">
          <h2 className="section-title">Latest Market Updates</h2>
          <div className="updates-filters">
            <button className="btn btn-sm btn-accent">All News</button>
            <button className="btn btn-outline btn-sm">Funding</button>
            <button className="btn btn-outline btn-sm">Launches</button>
            <button className="btn btn-outline btn-sm">Partnerships</button>
          </div>
        </div>
        <div className="updates-rail">
          <article className="updates-card">
            <div className="updates-card-image">
              <img
                src="https://images.pexels.com/photos/9574411/pexels-photo-9574411.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Lab Research"
              />
              <span className="updates-badge">Funding</span>
            </div>
            <div className="updates-card-content">
              <span className="updates-meta">TechCrunch • 2h ago</span>
              <h3 className="section-subtitle">
                MedCore Systems Secures $45M Series B for AI Diagnostics
              </h3>
              <p className="section-content">
                Dallas-based MedCore plans to expand its clinical trial
                operations across the Southern region.
              </p>
              <div className="updates-card-footer">
                <span className="updates-tag">#Biotech</span>
                <a href="#">
                  <div className="btn-link">
                    <span>Read More</span>
                  </div>
                </a>
              </div>
            </div>
          </article>
          <article className="updates-card">
            <div className="updates-card-image">
              <img
                src="https://images.pexels.com/photos/6285367/pexels-photo-6285367.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Digital Health"
              />
              <span className="updates-badge">Partnership</span>
            </div>
            <div className="updates-card-content">
              <span className="updates-meta">
                Dallas Business Journal • 5h ago
              </span>
              <h3 className="section-subtitle">
                HealthSync Announces Major Integration with Texas Health
              </h3>
              <p className="section-content">
                Strategic partnership aims to streamline patient data
                interoperability across 15 hospitals.
              </p>
              <div className="updates-card-footer">
                <span className="updates-tag">#DigitalHealth</span>
                <a href="#">
                  <div className="btn-link">
                    <span>Read More</span>
                  </div>
                </a>
              </div>
            </div>
          </article>
          <article className="updates-card">
            <div className="updates-card-image">
              <img
                src="https://images.pexels.com/photos/9574541/pexels-photo-9574541.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Tech Launch"
              />
              <span className="updates-badge">Product</span>
            </div>
            <div className="updates-card-content">
              <span className="updates-meta">Fierce Healthcare • 1d ago</span>
              <h3 className="section-subtitle">
                VitalsIQ Launches Real-time Monitoring Platform
              </h3>
              <p className="section-content">
                New SaaS solution targets remote patient monitoring for chronic
                care facilities in DFW.
              </p>
              <div className="updates-card-footer">
                <span className="updates-tag">#SaaS</span>
                <a href="#">
                  <div className="btn-link">
                    <span>Read More</span>
                  </div>
                </a>
              </div>
            </div>
          </article>
          <article className="updates-card">
            <div className="updates-card-image">
              <img
                src="https://images.pexels.com/photos/8539424/pexels-photo-8539424.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Investment news"
              />
              <span className="updates-badge">Funding</span>
            </div>
            <div className="updates-card-content">
              <span className="updates-meta">PR Newswire • 1d ago</span>
              <h3 className="section-subtitle">
                North Texas VC Fund Closes $200M Health-Tech Vehicle
              </h3>
              <p className="section-content">
                Fund will focus exclusively on early-stage life science startups
                in the Metroplex area.
              </p>
              <div className="updates-card-footer">
                <span className="updates-tag">#VentureCapital</span>
                <a href="#">
                  <div className="btn-link">
                    <span>Read More</span>
                  </div>
                </a>
              </div>
            </div>
          </article>
        </div>
      </section>
      <section className="news---insights-timeline-section">
        <div className="timeline-container">
          <div className="timeline-header">
            <h2 className="section-title">Recent Funding Rounds</h2>
            <p className="section-content">
              Tracking the flow of capital into the North Texas health
              technology ecosystem.
            </p>
          </div>
          <div className="timeline-vertical">
            <div className="timeline-item">
              <div className="timeline-marker"></div>
              <div className="timeline-content">
                <div className="timeline-date">
                  <span>Oct 24, 2023</span>
                </div>
                <div className="timeline-card">
                  <div className="timeline-card-header">
                    <h3 className="section-subtitle">BioWave Therapeutics</h3>
                    <span className="timeline-amount">$28.5M</span>
                  </div>
                  <p className="section-content">
                    <span className="news-insights-text16">Round:</span>
                    <span>
                      {' '}
                      Series A •
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <span className="news-insights-text18">Lead:</span>
                    <span> Perot Jain</span>
                  </p>
                  <p className="section-content">
                    Developing non-invasive neuromodulation devices for chronic
                    pain management.
                  </p>
                  <div className="timeline-links">
                    <a href="#">
                      <div className="btn-link">
                        <span>View Profile</span>
                      </div>
                    </a>
                    <a href="#">
                      <div className="btn-link">
                        <span>Coverage</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker"></div>
              <div className="timeline-content">
                <div className="timeline-date">
                  <span>Oct 18, 2023</span>
                </div>
                <div className="timeline-card">
                  <div className="timeline-card-header">
                    <h3 className="section-subtitle">CareAlign AI</h3>
                    <span className="timeline-amount">$4.2M</span>
                  </div>
                  <p className="section-content">
                    <span className="news-insights-text23">Round:</span>
                    <span>
                      {' '}
                      Seed •
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <span className="news-insights-text25">Lead:</span>
                    <span> Green Park &amp; Golf Ventures</span>
                  </p>
                  <p className="section-content">
                    Generative AI for physician workflow optimization and
                    clinical documentation.
                  </p>
                  <div className="timeline-links">
                    <a href="#">
                      <div className="btn-link">
                        <span>View Profile</span>
                      </div>
                    </a>
                    <a href="#">
                      <div className="btn-link">
                        <span>Coverage</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker"></div>
              <div className="timeline-content">
                <div className="timeline-date">
                  <span>Oct 12, 2023</span>
                </div>
                <div className="timeline-card">
                  <div className="timeline-card-header">
                    <h3 className="section-subtitle">NanoScan Diagnostics</h3>
                    <span className="timeline-amount">$12.0M</span>
                  </div>
                  <p className="section-content">
                    <span className="news-insights-text30">Round:</span>
                    <span>
                      {' '}
                      Venture •
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <span className="news-insights-text32">Lead:</span>
                    <span> Mercury Fund</span>
                  </p>
                  <p className="section-content">
                    Next-generation molecular imaging for early stage oncology
                    detection.
                  </p>
                  <div className="timeline-links">
                    <a href="#">
                      <div className="btn-link">
                        <span>View Profile</span>
                      </div>
                    </a>
                    <a href="#">
                      <div className="btn-link">
                        <span>Coverage</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="stats-section">
        <div className="stats-container">
          <div className="stats-header">
            <h2 className="section-title">Market Intelligence</h2>
            <p className="section-content">
              Key metrics reflecting the current state of DFW&apos;s health tech
              market performance.
            </p>
          </div>
          <div className="stats-grid">
            <div className="stats-item">
              <div className="stats-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M16 7h6v6"></path>
                    <path d="m22 7l-8.5 8.5l-5-5L2 17"></path>
                  </g>
                </svg>
              </div>
              <div className="stats-number">
                <span>342</span>
              </div>
              <div className="stats-label">
                <span>Active Companies</span>
              </div>
              <div className="stats-trend positive">
                <span>+12% vs LY</span>
              </div>
            </div>
            <div className="stats-item">
              <div className="stats-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 2v20m5-17H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
                  ></path>
                </svg>
              </div>
              <div className="stats-number">
                <span>$840M</span>
              </div>
              <div className="stats-label">
                <span>Total Q3 Funding</span>
              </div>
              <div className="stats-trend positive">
                <span>+24% vs Q2</span>
              </div>
            </div>
            <div className="stats-item">
              <div className="stats-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8m4 2V6"></path>
                  </g>
                </svg>
              </div>
              <div className="stats-number">
                <span>$18.4M</span>
              </div>
              <div className="stats-label">
                <span>Avg. Deal Size</span>
              </div>
              <div className="stats-trend neutral">
                <span>Stable</span>
              </div>
            </div>
            <div className="stats-item">
              <div className="stats-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <circle cx="10" cy="7" r="4"></circle>
                    <path d="M10.3 15H7a4 4 0 0 0-4 4v2"></path>
                    <circle cx="17" cy="17" r="3"></circle>
                    <path d="m21 21l-1.9-1.9"></path>
                  </g>
                </svg>
              </div>
              <div className="stats-number">
                <span>15.2k</span>
              </div>
              <div className="stats-label">
                <span>Tech Employees</span>
              </div>
              <div className="stats-trend positive">
                <span>+8% YTD</span>
              </div>
            </div>
            <div className="stats-item">
              <div className="stats-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M8 2v4m8-4v4"></path>
                    <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                    <path d="M3 10h18"></path>
                  </g>
                </svg>
              </div>
              <div className="stats-number">
                <span>12</span>
              </div>
              <div className="stats-label">
                <span>Exits (YTD)</span>
              </div>
              <div className="stats-trend positive">
                <span>Record High</span>
              </div>
            </div>
            <div className="stats-item">
              <div className="stats-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5M10 9H8m8 4H8m8 4H8"></path>
                  </g>
                </svg>
              </div>
              <div className="stats-number">
                <span>85%</span>
              </div>
              <div className="stats-label">
                <span>Market Confidence</span>
              </div>
              <div className="stats-trend positive">
                <span>Bullish</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="blog-section">
        <div className="blog-container">
          <div className="blog-header">
            <h2 className="section-title">Analyst Perspectives</h2>
            <p className="section-content">
              Deep dives into the trends shaping the future of North Texas
              healthcare innovation.
            </p>
          </div>
          <div className="blog-featured">
            <div className="blog-featured-image">
              <img
                src="https://images.pexels.com/photos/9574566/pexels-photo-9574566.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Analyst insights"
              />
            </div>
            <div className="blog-featured-content">
              <span className="blog-tag">Market Map</span>
              <h3 className="news---insights-hero-subtitle hero-subtitle">
                The 2024 DFW Health Tech Ecosystem Map: A 360° View
              </h3>
              <p className="section-content">
                Our analysts have mapped over 300 companies across 12
                sub-sectors. Discover the hidden clusters of innovation in Plano
                and Richardson that are attracting national capital.
              </p>
              <div className="blog-author">
                <div className="blog-author-info">
                  <strong>Sarah Jenkins</strong>
                  <span>Lead Market Analyst</span>
                </div>
                <a href="#">
                  <div className="btn btn-primary">
                    <span>Read Full Analysis</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className="blog-grid">
            <article className="blog-card">
              <h3 className="section-subtitle">
                Why DFW is the New Hub for Biotech Manufacturing
              </h3>
              <p className="section-content">
                Analyzing the shift from coastal hubs to the Metroplex for
                mid-stage clinical production.
              </p>
              <a href="#">
                <div className="btn-link">
                  <span>Read More</span>
                </div>
              </a>
            </article>
            <article className="blog-card">
              <h3 className="section-subtitle">
                The Role of AI in Texas Health Systems
              </h3>
              <p className="section-content">
                How local health giants are adopting generative AI to combat
                physician burnout.
              </p>
              <a href="#">
                <div className="btn-link">
                  <span>Read More</span>
                </div>
              </a>
            </article>
            <article className="blog-card">
              <h3 className="section-subtitle">
                Venture Outlook: Q4 2023 Expectations
              </h3>
              <p className="section-content">
                Anticipating deal flow and valuation trends for the final
                quarter of the year.
              </p>
              <a href="#">
                <div className="btn-link">
                  <span>Read More</span>
                </div>
              </a>
            </article>
          </div>
        </div>
      </section>
      <section className="resources-section">
        <div className="resources-container">
          <div className="resources-header">
            <h2 className="section-title">Premium Reports &amp; Resources</h2>
            <p className="section-content">
              Unlock proprietary data and comprehensive market maps designed for
              investors and founders.
            </p>
          </div>
          <div className="resources-grid">
            <div className="resources-item">
              <div className="resources-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5M10 9H8m8 4H8m8 4H8"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Q3 Market Report</h3>
              <p className="section-content">
                Complete breakdown of all 42 funding rounds in Q3 2023.
              </p>
              <button className="btn btn-outline btn-sm">Download PDF</button>
            </div>
            <div className="resources-item">
              <div className="resources-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="m12 16l4-4l-4-4m-4 4h8"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Investor Directory</h3>
              <p className="section-content">
                Verified list of 150+ VCs and Angels active in North Texas.
              </p>
              <button className="btn btn-outline btn-sm">Access Data</button>
            </div>
            <div className="resources-item">
              <div className="resources-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M11 22H5.5a1 1 0 0 1 0-5h4.501M21 22l-1.879-1.878"></path>
                    <path d="M3 19.5v-15A2.5 2.5 0 0 1 5.5 2H18a1 1 0 0 1 1 1v8"></path>
                    <circle cx="17" cy="18" r="3"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Sector Deep Dive</h3>
              <p className="section-content">
                Focus on Digital Therapeutics and Remote Monitoring trends.
              </p>
              <button className="btn btn-outline btn-sm">Read Report</button>
            </div>
            <div className="resources-item">
              <div className="resources-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M3 7V5a2 2 0 0 1 2-2h2m10 0h2a2 2 0 0 1 2 2v2m0 10v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                    <path d="m16 16l-1.9-1.9"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Talent Heatmap</h3>
              <p className="section-content">
                Visualizing the flow of tech talent between DFW health systems.
              </p>
              <button className="btn btn-outline btn-sm">View Map</button>
            </div>
            <div className="resources-item">
              <div className="resources-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M16 7h6v6"></path>
                    <path d="m22 7l-8.5 8.5l-5-5L2 17"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Growth Forecast</h3>
              <p className="section-content">
                Analyst projections for the Metroplex health tech sector through
                2026.
              </p>
              <button className="btn btn-outline btn-sm">Get Insights</button>
            </div>
            <div className="resources-item">
              <div className="resources-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8m4 2V6"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Exit Strategy Guide</h3>
              <p className="section-content">
                Best practices for health-tech founders eye-ing acquisitions.
              </p>
              <button className="btn btn-outline btn-sm">Download Guide</button>
            </div>
          </div>
        </div>
      </section>
      <section className="cta-section">
        <div className="cta-container">
          <div className="cta-card">
            <div className="news---insights-cta-content">
              <h2 className="section-title">Stay Ahead of the Pulse</h2>
              <p className="section-content">
                Join the DFW Health Tech newsletter. Every Monday, we deliver a
                curated briefing of funding rounds, market shifts, and analyst
                insights directly to your inbox.
              </p>
              <ul className="cta-benefits">
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 12h14m-7-7l7 7l-7 7"
                    ></path>
                  </svg>
                  <span>Exclusive early access to market maps</span>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 12h14m-7-7l7 7l-7 7"
                    ></path>
                  </svg>
                  <span>Weekly summary of North Texas funding</span>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 12h14m-7-7l7 7l-7 7"
                    ></path>
                  </svg>
                  <span>Analyst-curated &quot;Must Read&quot; news list</span>
                </li>
              </ul>
            </div>
            <div className="cta-form-wrapper">
              <form
                action="#"
                method="POST"
                data-form-id="24bf2e95-b043-407d-96fe-53b62f33e7ab"
                className="cta-form"
              >
                <div className="cta-input-group">
                  <input
                    type="email"
                    placeholder="Work Email"
                    required="true"
                    id="thq_textinput_ZEMm"
                    name="textinput"
                    data-form-field-id="thq_textinput_ZEMm"
                    className="news---insights-cta-input"
                  />
                  <button
                    type="submit"
                    id="thq_button__KYP"
                    name="button"
                    data-form-field-id="thq_button__KYP"
                    className="btn btn-accent btn-lg"
                  >
                    Subscribe Now
                  </button>
                </div>
                <p className="cta-disclaimer">
                  No spam. Only high-signal intelligence. Unsubscribe at any
                  time.
                </p>
              </form>
            </div>
          </div>
        </div>
      </section>
      <div className="news-insights-container2">
        <div className="news-insights-container3">
          <Script
            html={`<script defer data-name="hero-search-interaction">
(function(){
  const searchInput = document.querySelector('.hero-input');
  const searchBtn = document.querySelector('.hero-search-bar .btn-primary');

  if (searchBtn && searchInput) {
    searchBtn.addEventListener('click', () => {
      const query = searchInput.value.trim();
      if (query) {
        console.log('Searching DFW health tech for:', query);
        // In production, this would redirect to search results
      }
    });

    searchInput.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        searchBtn.click();
      }
    });
  }

  // Horizontal Scroll with Mouse Wheel for Updates Rail
  const scrollRail = document.querySelector('.updates-rail');
  if (scrollRail) {
    scrollRail.addEventListener('wheel', (e) => {
      if (e.deltaY !== 0) {
        e.preventDefault();
        scrollRail.scrollLeft += e.deltaY;
      }
    });
  }

  // Newsletter Form Logic
  const ctaForm = document.querySelector('.cta-form');
  if (ctaForm) {
    ctaForm.addEventListener('submit', (e) => {
      // Form uses native validation, this is for UX feedback
      const email = ctaForm.querySelector('input[type="email"]').value;
      console.log('Newsletter subscription request for:', email);
      
      // Visual feedback placeholder
      const submitBtn = ctaForm.querySelector('button');
      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'Subscribed!';
      submitBtn.classList.replace('btn-accent', 'btn-primary');
      submitBtn.disabled = true;
    });
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default NewsInsights
